export default "__VITE_ASSET__CpThv9ZC__"